import { FieldValues, FormState } from 'react-hook-form';
import type { TextFieldProps } from '@carrotfertility/carotene-core';
import { RequireNameProp } from './form-types';

type GetFormInputState<T extends FieldValues> = Pick<FormState<T>, 'errors'> &
    RequireNameProp &
    Pick<TextFieldProps, 'error' | 'helperText'>;

export function getFormInputState<T extends FieldValues>(args: GetFormInputState<T>) {
    return {
        error: args?.error || Boolean(args?.errors[args?.name]),
        helperText: args?.errors[args?.name] ? args?.errors[args?.name]?.message?.toString() : args?.helperText,
    };
}
